// extracted by mini-css-extract-plugin
module.exports = {"costType":"TripCartAsidePriceHeader_costType__Sxsd7","root":"TripCartAsidePriceHeader_root__H8a69","left":"TripCartAsidePriceHeader_left__Qjrpk"};